/**
 * Ambiente "atual" da corretora primary do ponto de vista da UI.
 * É a lente global: filtra listas (automações, ordens, performance) e
 * define o env em que novas automações nascem.
 *
 * Não é o ambiente "do sistema" (NODE_ENV) — é a preferência do usuário
 * sobre qual ambiente da corretora primary ele está vendo/operando agora
 * ('production' ou 'test').
 *
 * Persiste em localStorage para sobreviver entre sessões. Migra
 * automaticamente da chave antiga `defaultOperationMode`.
 */

const KEY = 'currentEnvironment';
const LEGACY_KEY = 'defaultOperationMode';

const listeners = new Set();

function _normalize(value) {
    return value === 'test' ? 'test' : 'production';
}

function _migrate() {
    if (localStorage.getItem(KEY) !== null) return;
    const legacy = localStorage.getItem(LEGACY_KEY);
    if (legacy !== null) {
        localStorage.setItem(KEY, _normalize(legacy));
        localStorage.removeItem(LEGACY_KEY);
    }
}

export function getCurrentEnvironment() {
    _migrate();
    const value = localStorage.getItem(KEY);
    return _normalize(value);
}

export function setCurrentEnvironment(environment) {
    const safe = _normalize(environment);
    const prev = localStorage.getItem(KEY);
    localStorage.setItem(KEY, safe);
    if (prev !== safe) listeners.forEach(fn => { try { fn(safe); } catch (_) {} });
}

/** Inscreve callback para mudanças. Retorna função de unsubscribe. */
export function subscribeToCurrentEnvironment(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}
